import { render, staticRenderFns } from "./MassiveCancelPackageForm.vue?vue&type=template&id=3866b30e&lang=pug"
import script from "./MassiveCancelPackageForm.vue?vue&type=script&lang=js"
export * from "./MassiveCancelPackageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports